export default __webpack_public_path__ + "static/media/right_control.f6145de8.svg";